module.exports = __webpack_public_path__ + "img/PoliticsCritical.3b70f027.svg";